import appModule from './app.module';

appModule.config($stateProvider =>
    $stateProvider
        .state({
            name: 'app',
            url: '',
            component: 'appRoot',
            redirectTo: 'license_overview'
        })
        .state({
            parent: 'app',
            name: 'app/otherwise',
            url: '/*path',
            redirectTo: 'license_overview'
        })
);



// WEBPACK FOOTER //
// ./app.states.js